<template>
  <div>
    <a-icon v-if="submitting" class="spinner" type="loading" />
    <form :class="{ 'submitting': submitting }" @submit.prevent='handleSubmit'>
      <h1>New user</h1>
      <div class='form-row' :class="{ 'form-group--error': $v.newUser.firstName.$error }">
        <label for='firstName'>First name</label>
        <input name='firstName' type='text' placeholder="Enter first name" v-model.trim.lazy="$v.newUser.firstName.$model" @keydown='clearError($v.newUser.firstName)' />
        <div class="error" v-if="!$v.newUser.firstName.required && $v.newUser.firstName.$error">Required</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.newUser.lastName.$error }">
        <label for='lastName'>Last name</label>
        <input name='lastName' type='text' placeholder="Enter last name" v-model.trim.lazy="$v.newUser.lastName.$model" @keydown='clearError($v.newUser.lastName)' />
        <div class="error" v-if="!$v.newUser.lastName.required && $v.newUser.lastName.$error">Required</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.newUser.email.$error }">
        <label for='email'>Email</label>
        <input name='email' type='text' placeholder="Enter email address" v-model.trim.lazy="$v.newUser.email.$model" @keydown='clearError($v.newUser.email)' />
        <div class="error" v-if="!$v.newUser.email.required && $v.newUser.email.$error">Required</div>
        <div class="error" v-if="!$v.newUser.email.email && $v.newUser.email.$error">Check format</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.newUser.password.$error }">
        <label for='password'>Password</label>
        <input name='password' type='text' placeholder="Enter password (min. 8 chars)" v-model.trim.lazy="$v.newUser.password.$model" @keydown='clearError($v.newUser.password)' />
        <div class="error" v-if="!$v.newUser.password.required && $v.newUser.password.$error">Required</div>
        <div class="error" v-if="!$v.newUser.password.minLength && $v.newUser.password.$error">Min. 8 chars</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.newUser.confirmPassword.$error }">
        <label for='confirmPassword'>Confirm password</label>
        <input name='confirmPassword' type='text' placeholder="Enter password again" v-model.trim.lazy="$v.newUser.confirmPassword.$model" @keydown='clearError($v.newUser.confirmPassword)' />
        <div class="error" v-if="!$v.newUser.confirmPassword.sameAsPassword && $v.newUser.confirmPassword.$error">Not a match</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.newUser.subscription.$error }">
        <label>Subscription</label>
        <SubscriptionAutocomplete :onBlur="onBlur" v-model="$v.newUser.subscription.$model" />
        <div class="error" v-if="!$v.newUser.subscription.required && $v.newUser.subscription.$error">Required</div>
      </div>

      <div class="ant-modal-footer">
        <div class='flat-button' @click='closeForm'>Cancel</div>
        <button class='raised-button' type="submit" :disabled='$v.newUser.$invalid || submitting'>Save User</button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import SubscriptionAutocomplete from '@/components/subscriptions/SubscriptionAutocomplete'
  import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

  export default  {
    name: 'NewUserForm',
    components: {
      SubscriptionAutocomplete
    },
    validations: {
      newUser: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required,
          minLength: minLength(6),
          email
        },
        password: {
          required,
          minLength: minLength(8)
        },
        confirmPassword: {
          required,
          sameAsPassword: sameAs('password')
        },
        subscription: {
          required
        }
      },
    },
    computed: {
      ...mapState('newUserForm', ['newUser', 'submitting'])
    },
    methods: {
      ...mapMutations('newUserForm', { closeForm: 'close' }),
      ...mapActions('newUserForm', ['postUser']),
      handleSubmit(event) {
        this.postUser(this.newUser)
        this.$nextTick(() => { this.$v.$reset() })
      },
      clearError(input) {
       input.$reset()
      },
      onBlur() {
        this.$v.newUser.subscription.$touch();
      }
    },
  }
</script>

<style scoped lang="stylus">
  @import '../styles/buttons'
  @import '../styles/forms'
</style>